<template>
	<section class="main_banner_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-5 d600-none">
					<div class="ban_rt">
						<img :src="img.image50" alt="Logo" />
					</div>
				</div>
				<div class="col-sm-7">
					<div class="ban_lt">
						<h5>
							<span>
								{{ $t('new_ui.home_page.section_main_banner.title.one') }}
							</span>
							{{ $t('new_ui.home_page.section_main_banner.title.two') }}
						</h5>
						<h2>
							{{ $t('new_ui.home_page.section_main_banner.title.three') }}
						</h2>
						<h6>
							{{ $t('new_ui.home_page.section_main_banner.title.four') }}
							<span>
								{{ $t('new_ui.home_page.section_main_banner.title.five') }}
							</span>
							{{ $t('new_ui.home_page.section_main_banner.title.six') }}
						</h6>
						<p>
							{{ $t('new_ui.home_page.section_main_banner.description.one')
							}}<br />
							{{ $t('new_ui.home_page.section_main_banner.description.two') }}
							<br />
							{{ $t('new_ui.home_page.section_main_banner.description.three') }}
						</p>
						<!-- <div
							class="ban_lt_btn d-flex justify-content-start align-items-center"
						>
							<a href="#">
								{{ $t('new_ui.home_page.section_main_banner.cta_buttons.one') }}
							</a>
							<a href="#" class="back_off">
								{{ $t('new_ui.home_page.section_main_banner.cta_buttons.two') }}
							</a>
						</div> -->
					</div>
				</div>
				<div class="col-sm-5 d600-block">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<!-- Safety speed Mobile Swiper -->
	<section class="safety_speed_mob">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="safety_slider">
						<swiper
							:slides-per-view="1"
							:space-between="30"
							:loop="true"
							:pagination="{
								el: '.swiper-pagination-1',
								clickable: true,
							}"
							:autoplay="{ delay: 2000, disableOnInteraction: false }"
							:breakpoints="{
								0: { slidesPerView: 1 },
								600: { slidesPerView: 1.5 },
								768: { slidesPerView: 2 },
								1000: { slidesPerView: 3 },
								1200: { slidesPerView: 4.5 },
							}"
						>
							<swiper-slide>
								<div class="banner_panel">
									<h6>
										{{
											$t(
												'new_ui.home_page.section_safety_speed.cards.secure_payment.title',
											)
										}}
									</h6>
									<div class="banner_panel_dwn">
										<div class="banner_panel_dwn_lt">
											<img :src="img.image2" alt="Logo" />
										</div>
										<div class="banner_panel_dwn_rt">
											<p>
												{{
													$t(
														'new_ui.home_page.section_safety_speed.cards.secure_payment.description',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</swiper-slide>
							<swiper-slide>
								<div class="banner_panel">
									<h6>
										{{
											$t(
												'new_ui.home_page.section_safety_speed.cards.any_company.title',
											)
										}}
									</h6>
									<div class="banner_panel_dwn">
										<div class="banner_panel_dwn_lt">
											<img :src="img.image3" alt="Logo" />
										</div>
										<div class="banner_panel_dwn_rt">
											<p>
												{{
													$t(
														'new_ui.home_page.section_safety_speed.cards.any_company.description',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</swiper-slide>
							<swiper-slide>
								<div class="banner_panel">
									<h6>
										{{
											$t(
												'new_ui.home_page.section_safety_speed.cards.touch_free.title',
											)
										}}
									</h6>
									<div class="banner_panel_dwn">
										<div class="banner_panel_dwn_lt">
											<img :src="img.image4" alt="Logo" />
										</div>
										<div class="banner_panel_dwn_rt">
											<p>
												{{
													$t(
														'new_ui.home_page.section_safety_speed.cards.touch_free.description',
													)
												}}
											</p>
										</div>
									</div>
								</div>
							</swiper-slide>
						</swiper>
						<!-- Move pagination outside swiper -->
						<div class="swiper-pagination-1"></div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="safety_speed_sec">
		<div class="container">
			<div class="row safety_desk">
				<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
					<div class="banner_panel">
						<h6>
							{{
								$t(
									'new_ui.home_page.section_safety_speed.cards.secure_payment.title',
								)
							}}
						</h6>
						<div class="banner_panel_dwn">
							<div class="banner_panel_dwn_lt">
								<img :src="img.image2" alt="Logo" />
							</div>
							<div class="banner_panel_dwn_rt">
								<p>
									{{
										$t(
											'new_ui.home_page.section_safety_speed.cards.secure_payment.description',
										)
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
					<div class="banner_panel">
						<h6>
							{{
								$t(
									'new_ui.home_page.section_safety_speed.cards.any_company.title',
								)
							}}
						</h6>
						<div class="banner_panel_dwn">
							<div class="banner_panel_dwn_lt">
								<img :src="img.image3" alt="Logo" />
							</div>
							<div class="banner_panel_dwn_rt">
								<p>
									{{
										$t(
											'new_ui.home_page.section_safety_speed.cards.any_company.description',
										)
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-4 col-xl-4 col-lg-4 col-md-6">
					<div class="banner_panel">
						<h6>
							{{
								$t(
									'new_ui.home_page.section_safety_speed.cards.touch_free.title',
								)
							}}
						</h6>
						<div class="banner_panel_dwn">
							<div class="banner_panel_dwn_lt">
								<img :src="img.image4" alt="Logo" />
							</div>
							<div class="banner_panel_dwn_rt">
								<p>
									{{
										$t(
											'new_ui.home_page.section_safety_speed.cards.touch_free.description',
										)
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="safety_block_panel">
				<div class="row">
					<div class="col-sm-6">
						<div class="safety_speed_lt">
							<span>{{
								$t(
									'new_ui.home_page.section_safety_speed.fastest_payment.label',
								)
							}}</span>
							<div class="safety_speed_text">
								<h4>
									{{
										$t(
											'new_ui.home_page.section_safety_speed.fastest_payment.title.one',
										)
									}}
									<span>{{
										$t(
											'new_ui.home_page.section_safety_speed.fastest_payment.title.two',
										)
									}}</span>

									<span>{{
										$t(
											'new_ui.home_page.section_safety_speed.fastest_payment.title.three',
										)
									}}</span>
									{{
										$t(
											'new_ui.home_page.section_safety_speed.fastest_payment.title.four',
										)
									}}
								</h4>
								<p>
									{{
										$t(
											'new_ui.home_page.section_safety_speed.fastest_payment.description',
										)
									}}
								</p>
								<img :src="img.image5" alt="Logo" />
							</div>
						</div>
					</div>
					<div class="col-sm-6">
						<div class="safety_speed_rt">
							<div class="safety_speed_rt_img">
								<img :src="img.image6" alt="" />
							</div>
							<div class="safety_content">
								<div class="safety_content_lt">
									<div class="safety_content_lt_up">
										<div><img :src="img.image7" alt="" /></div>
										<div class="regis_txt">
											<h4>
												{{
													$t(
														'new_ui.home_page.section_safety_speed.registration.title',
													)
												}}
											</h4>
										</div>
									</div>
									<div class="safety_content_lt_dwn">
										<p>
											{{
												$t(
													'new_ui.home_page.section_safety_speed.registration.description',
												)
											}}
										</p>
									</div>
								</div>
								<div class="safety_content_lt">
									<div class="safety_content_lt_up">
										<div><img :src="img.image8" alt="" /></div>
										<div class="regis_txt">
											<h4>
												{{
													$t(
														'new_ui.home_page.section_safety_speed.start_payment.title',
													)
												}}
											</h4>
										</div>
									</div>
									<div class="safety_content_lt_dwn">
										<p>
											{{
												$t(
													'new_ui.home_page.section_safety_speed.start_payment.description',
												)
											}}
										</p>
									</div>
								</div>
							</div>
							<div class="starting_to_btn">
								<a href="/auth/register">{{
									$t('new_ui.home_page.section_safety_speed.cta_button')
								}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="we_offer_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="we_offer_inn home_enjoy">
						<span>{{ $t('new_ui.home_page.section_we_offer.title.one') }}</span>
						<h5>
							{{ $t('new_ui.home_page.section_we_offer.title.two') }}
							<span>{{
								$t('new_ui.home_page.section_we_offer.title.three')
							}}</span>
						</h5>
						<p>
							{{ $t('new_ui.home_page.section_we_offer.description') }}
						</p>
						<div class="enjoy_shopping_sec enjoy_desk">
							<h6>
								{{
									$t('new_ui.home_page.section_we_offer.enjoy_shopping.title')
								}}
							</h6>
							<p>
								{{
									$t(
										'new_ui.home_page.section_we_offer.enjoy_shopping.description',
									)
								}}
							</p>

							<div class="enjoy_shopping_box_sec">
								<div class="enjoy_shopping_inn">
									<div class="enjoy_shopping_box">
										<img :src="img.image9" alt="" />
										<div class="offer_round">1</div>
									</div>
									<div class="enjoy_shopping_dwn">
										<h6>
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.one.title',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.one.description.one',
												)
											}}
											<br />
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.one.description.two',
												)
											}}
										</p>
									</div>
								</div>

								<div class="enjoy_shopping_inn shoping_mid">
									<div class="enjoy_shopping_box">
										<img :src="img.image10" alt="" />
										<div class="offer_round offer_round2">2</div>
									</div>
									<div class="enjoy_shopping_dwn">
										<h6>
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.two.title',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.two.description.one',
												)
											}}
											<br />
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.two.description.two',
												)
											}}
										</p>
									</div>
								</div>

								<div class="enjoy_shopping_inn">
									<div class="enjoy_shopping_box">
										<img :src="img.image11" alt="" />
										<div class="offer_round">3</div>
									</div>
									<div class="enjoy_shopping_dwn">
										<h6>
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.three.title',
												)
											}}
										</h6>
										<p>
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.three.description.one',
												)
											}}
											<br />
											{{
												$t(
													'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.three.description.two',
												)
											}}
										</p>
									</div>
								</div>
							</div>

							<div class="starting_to_btn">
								<a href="/auth/register">
									{{
										$t(
											'new_ui.home_page.section_we_offer.enjoy_shopping.cta_button',
										)
									}}</a
								>
							</div>
						</div>

						<div class="enjoy_shopping_sec enjoy_mob">
							<h6>
								{{
									$t('new_ui.home_page.section_we_offer.enjoy_shopping.title')
								}}
							</h6>
							<p>
								{{
									$t(
										'new_ui.home_page.section_we_offer.enjoy_shopping.description',
									)
								}}
							</p>

							<div class="enjoy_slider">
								<swiper
									:slides-per-view="1"
									:space-between="30"
									:loop="true"
									:pagination="{
										el: '.swiper-pagination-2',
										clickable: true,
									}"
									:autoplay="{ delay: 2000, disableOnInteraction: false }"
									:breakpoints="{
										0: { slidesPerView: 1 },
										600: { slidesPerView: 1.5 },
										768: { slidesPerView: 2 },
										1000: { slidesPerView: 3 },
										1200: { slidesPerView: 4.5 },
									}"
								>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image9" alt="" />
												<div class="offer_round">1</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.one.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.one.description.one',
														)
													}}
													<br />
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.one.description.two',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image10" alt="" />
												<div class="offer_round offer_round2">2</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.two.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.two.description.one',
														)
													}}
													<br />
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.two.description.two',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
									<swiper-slide>
										<div class="enjoy_shopping_inn">
											<div class="enjoy_shopping_box">
												<img :src="img.image11" alt="" />
												<div class="offer_round">3</div>
											</div>
											<div class="enjoy_shopping_dwn">
												<h6>
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.three.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.three.description.one',
														)
													}}
													<br />
													{{
														$t(
															'new_ui.home_page.section_we_offer.enjoy_shopping.boxes.three.description.two',
														)
													}}
												</p>
											</div>
										</div>
									</swiper-slide>
								</swiper>
								<!-- Move pagination outside swiper -->
								<div class="swiper-pagination-2"></div>
							</div>

							<div class="starting_to_btn">
								<a href="/auth/register">
									{{
										$t(
											'new_ui.home_page.section_we_offer.enjoy_shopping.cta_button',
										)
									}}</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="payment_free">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12">
					<div class="payment_world_sec">
						<div class="payment_world_inn"></div>
						<img :src="img.image15" alt="" />
					</div>
				</div>
				<div class="col-sm-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12">
					<div class="payment_world_right">
						<span>{{
							$t('new_ui.home_page.section_payment_free.desktop.label')
						}}</span>
						<div class="payment_world_txt">
							<h4>
								{{
									$t('new_ui.home_page.section_payment_free.desktop.title.one')
								}}<br />
								<span>{{
									$t('new_ui.home_page.section_payment_free.desktop.title.two')
								}}</span>
								{{
									$t(
										'new_ui.home_page.section_payment_free.desktop.title.three',
									)
								}}
							</h4>
							<p>
								{{
									$t(
										'new_ui.home_page.section_payment_free.desktop.descriptionFirst',
									)
								}}
							</p>
							<p>
								{{
									$t(
										'new_ui.home_page.section_payment_free.desktop.descriptionSecond',
									)
								}}
							</p>
							<div class="starting_to_btn pay_world">
								<a href="/auth/register">{{
									$t('new_ui.home_page.section_payment_free.desktop.cta_button')
								}}</a>
							</div>
						</div>
					</div>
				</div>

				<div class="col-sm-12 business_mob">
					<div class="business_anywhere_inn">
						<div class="row">
							<div class="col-sm-6 order-2 order-lg-1">
								<div class="business_anywhere_lt">
									<span>
										{{
											$t('new_ui.home_page.section_payment_free.mobile.label')
										}}
									</span>
									<div class="business_anywhere_txt">
										<h4>
											<span>{{
												$t(
													'new_ui.home_page.section_payment_free.mobile.title.one',
												)
											}}</span>
											{{
												$t(
													'new_ui.home_page.section_payment_free.mobile.title.two',
												)
											}}
										</h4>
										<p>
											{{
												$t(
													'new_ui.home_page.section_payment_free.mobile.description',
												)
											}}
										</p>
										<div class="starting_to_btn">
											<a href="/auth/register">{{
												$t(
													'new_ui.home_page.section_payment_free.mobile.cta_button',
												)
											}}</a>
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-6 order-1 order-lg-2">
								<div class="business_anywhere_rt">
									<img :src="img.image16" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="business_anywhere">
		<div class="container">
			<div class="business_anywhere_inn business_desk">
				<div class="row">
					<div class="col-sm-6 order-2 order-lg-1">
						<div class="business_anywhere_lt">
							<span>
								{{ $t('new_ui.home_page.section_business_anywhere.label') }}
							</span>
							<div class="business_anywhere_txt">
								<h4>
									<span>
										{{
											$t('new_ui.home_page.section_business_anywhere.title.one')
										}}
									</span>
									{{
										$t('new_ui.home_page.section_business_anywhere.title.two')
									}}
								</h4>
								<p>
									{{
										$t('new_ui.home_page.section_business_anywhere.description')
									}}
								</p>
								<div class="starting_to_btn">
									<a href="/auth/register">
										{{
											$t(
												'new_ui.home_page.section_business_anywhere.cta_button',
											)
										}}
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 order-1 order-lg-2">
						<div class="business_anywhere_rt">
							<img :src="img.image16" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="advantage_sec home_adv">
				<div class="row">
					<div
						class="col-sm-12 order-2 order-lg-1 col-xxl-9 col-xl-9 col-lg-9 col-md-12"
					>
						<div class="advantage_lt">
							<span>
								{{
									$t(
										'new_ui.home_page.section_business_anywhere.advantage.label',
									)
								}}
							</span>
							<div class="advantage_lt_inn">
								<h4>
									{{
										$t(
											'new_ui.home_page.section_business_anywhere.advantage.title.one',
										)
									}}
									<span>{{
										$t(
											'new_ui.home_page.section_business_anywhere.advantage.title.two',
										)
									}}</span
									>{{
										$t(
											'new_ui.home_page.section_business_anywhere.advantage.title.three',
										)
									}}
									<br />
									{{
										$t(
											'new_ui.home_page.section_business_anywhere.advantage.title.four',
										)
									}}
									<span>
										{{
											$t(
												'new_ui.home_page.section_business_anywhere.advantage.title.five',
											)
										}}
									</span>
								</h4>
							</div>
						</div>
						<div class="row">
							<div
								class="col-sm-12 col-xxl-3 col-xl-3 col-lg-4 col-md-4 d-none d-sm-block"
							>
								<div class="advantage_lt_imgbox">
									<img :src="img.image17" alt="" />
								</div>
							</div>

							<!-- image18: show only on <600px -->
							<div
								class="col-sm-12 col-xxl-3 col-xl-3 col-lg-4 col-md-4 d-block d-sm-none"
							>
								<div class="advantage_lt_imgbox">
									<img :src="img.image51" alt="" />
								</div>
							</div>
							<div class="col-sm-12 col-xxl-9 col-xl-9 col-lg-8 col-md-8">
								<div class="advantage_payment">
									<p>
										{{
											$t(
												'new_ui.home_page.section_business_anywhere.advantage.description',
											)
										}}
									</p>
									<div class="code_pos_sec code_desk">
										<div class="code_pos_sec_inn">
											<div class="code_pos_sec_inn_lt">
												<img :src="img.image18" alt="" />
											</div>
											<div class="code_pos_sec_inn_rt">
												<h6>
													{{
														$t(
															'new_ui.home_page.section_business_anywhere.advantage.payment_methods.qr_code.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.home_page.section_business_anywhere.advantage.payment_methods.qr_code.description',
														)
													}}
												</p>
											</div>
										</div>
										<div class="code_pos_sec_inn">
											<div class="code_pos_sec_inn_lt">
												<img :src="img.image19" alt="" />
											</div>
											<div class="code_pos_sec_inn_rt">
												<h6>
													{{
														$t(
															'new_ui.home_page.section_business_anywhere.advantage.payment_methods.onetether.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.home_page.section_business_anywhere.advantage.payment_methods.onetether.description',
														)
													}}
												</p>
											</div>
										</div>
										<div class="code_pos_sec_inn">
											<div class="code_pos_sec_inn_lt">
												<img :src="img.image20" alt="" />
											</div>
											<div class="code_pos_sec_inn_rt">
												<h6>
													{{
														$t(
															'new_ui.home_page.section_business_anywhere.advantage.payment_methods.kiosk.title',
														)
													}}
												</h6>
												<p>
													{{
														$t(
															'new_ui.home_page.section_business_anywhere.advantage.payment_methods.kiosk.description',
														)
													}}
												</p>
											</div>
										</div>
									</div>

									<div class="code_mob_slider">
										<swiper
											:slides-per-view="1"
											:space-between="30"
											:loop="true"
											:pagination="{
												el: '.swiper-pagination-3',
												clickable: true,
											}"
											:autoplay="{ delay: 2000, disableOnInteraction: false }"
											:breakpoints="{
												0: { slidesPerView: 1 },
												600: { slidesPerView: 1.5 },
												768: { slidesPerView: 2 },
												1000: { slidesPerView: 1 },
												1200: { slidesPerView: 1 },
											}"
										>
											<swiper-slide>
												<div class="code_pos_sec_inn">
													<div class="code_pos_sec_inn_lt">
														<img :src="img.image18" alt="" />
													</div>
													<div class="code_pos_sec_inn_rt">
														<h6>
															{{
																$t(
																	'new_ui.home_page.section_business_anywhere.advantage.payment_methods.qr_code.title',
																)
															}}
														</h6>
														<p>
															{{
																$t(
																	'new_ui.home_page.section_business_anywhere.advantage.payment_methods.qr_code.description',
																)
															}}
														</p>
													</div>
												</div>
											</swiper-slide>
											<swiper-slide>
												<div class="code_pos_sec_inn">
													<div class="code_pos_sec_inn_lt">
														<img :src="img.image19" alt="" />
													</div>
													<div class="code_pos_sec_inn_rt">
														<h6>
															{{
																$t(
																	'new_ui.home_page.section_business_anywhere.advantage.payment_methods.onetether.title',
																)
															}}
														</h6>
														<p>
															{{
																$t(
																	'new_ui.home_page.section_business_anywhere.advantage.payment_methods.onetether.description',
																)
															}}
														</p>
													</div>
												</div>
											</swiper-slide>
											<swiper-slide>
												<div class="code_pos_sec_inn">
													<div class="code_pos_sec_inn_lt">
														<img :src="img.image20" alt="" />
													</div>
													<div class="code_pos_sec_inn_rt">
														<h6>
															{{
																$t(
																	'new_ui.home_page.section_business_anywhere.advantage.payment_methods.kiosk.title',
																)
															}}
														</h6>
														<p>
															{{
																$t(
																	'new_ui.home_page.section_business_anywhere.advantage.payment_methods.kiosk.description',
																)
															}}
														</p>
													</div>
												</div>
											</swiper-slide>
										</swiper>
										<!-- Move pagination outside swiper -->
										<div class="swiper-pagination-3"></div>
									</div>

									<div class="starting_to_btn mt-4">
										<a href="/auth/register">
											{{
												$t(
													'new_ui.home_page.section_business_anywhere.advantage.cta_button',
												)
											}}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="col-sm-12 order-1 order-lg-2 col-xxl-3 col-xl-3 col-lg-3 col-md-12"
					>
						<div class="advantage_rt">
							<img :src="img.image21" alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image22" alt="" />
					</div>
				</div>
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image52" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{ $t('new_ui.home_page.section_question.label') }}</span>
							<div class="payment_world_txt">
								<h4>
									{{ $t('new_ui.home_page.section_question.title.one') }}
									<span>{{
										$t('new_ui.home_page.section_question.title.two')
									}}</span>
								</h4>
								<p>
									{{ $t('new_ui.home_page.section_question.description') }}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t('new_ui.home_page.section_question.cta_button')
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="growth_sec">
		<div class="container growth_desk">
			<div class="row">
				<div class="col-sm-4">
					<div class="growth_inn">
						<div class="growth_inn_lt">
							<img :src="img.image23" alt="" />
						</div>
						<div class="growth_inn_rt">
							<h3>
								{{
									$t(
										'new_ui.home_page.section_growth.stats.total_customers.value',
									)
								}}
							</h3>
							<p>
								{{
									$t(
										'new_ui.home_page.section_growth.stats.total_customers.label',
									)
								}}
							</p>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="growth_inn">
						<div class="growth_inn_lt">
							<img :src="img.image24" alt="" />
						</div>
						<div class="growth_inn_rt">
							<h3>
								{{
									$t(
										'new_ui.home_page.section_growth.stats.customer_satisfaction.value',
									)
								}}
							</h3>
							<p>
								{{
									$t(
										'new_ui.home_page.section_growth.stats.customer_satisfaction.label',
									)
								}}
							</p>
						</div>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="growth_inn">
						<div class="growth_inn_lt">
							<img :src="img.image25" alt="" />
						</div>
						<div class="growth_inn_rt">
							<h3>
								{{
									$t(
										'new_ui.home_page.section_growth.stats.money_managed.value',
									)
								}}
							</h3>
							<p>
								{{
									$t(
										'new_ui.home_page.section_growth.stats.money_managed.label',
									)
								}}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="growth_mob">
			<div class="testi_slider">
				<swiper
					:slides-per-view="1.3"
					:space-between="5"
					:loop="true"
					:loopAdditional-slides="6"
					:centered-slides="true"
					:pagination="{
						el: '.swiper-pagination-5',
						clickable: true,
					}"
					:autoplay="{ delay: 2000, disableOnInteraction: false }"
				>
					<swiper-slide>
						<div class="growth_inn">
							<div class="growth_inn_lt">
								<img :src="img.image23" alt="" />
							</div>
							<div class="growth_inn_rt">
								<h3>
									{{
										$t(
											'new_ui.home_page.section_growth.stats.total_customers.value',
										)
									}}
								</h3>
								<p>
									{{
										$t(
											'new_ui.home_page.section_growth.stats.total_customers.label',
										)
									}}
								</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="growth_inn">
							<div class="growth_inn_lt">
								<img :src="img.image24" alt="" />
							</div>
							<div class="growth_inn_rt">
								<h3>
									{{
										$t(
											'new_ui.home_page.section_growth.stats.customer_satisfaction.value',
										)
									}}
								</h3>
								<p>
									{{
										$t(
											'new_ui.home_page.section_growth.stats.customer_satisfaction.label',
										)
									}}
								</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="growth_inn">
							<div class="growth_inn_lt">
								<img :src="img.image25" alt="" />
							</div>
							<div class="growth_inn_rt">
								<h3>
									{{
										$t(
											'new_ui.home_page.section_growth.stats.money_managed.value',
										)
									}}
								</h3>
								<p>
									{{
										$t(
											'new_ui.home_page.section_growth.stats.money_managed.label',
										)
									}}
								</p>
							</div>
						</div>
					</swiper-slide>
				</swiper>
				<!-- Move pagination outside swiper -->
				<div class="swiper-pagination-5"></div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{ $t('new_ui.home_page.section_newsletter.label') }}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t('new_ui.home_page.section_newsletter.title.one')
								}}</span>
								{{ $t('new_ui.home_page.section_newsletter.title.two') }}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{ $t('new_ui.home_page.section_newsletter.description.one') }}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t('new_ui.home_page.section_newsletter.form.placeholder')
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{ $t('new_ui.home_page.section_newsletter.form.button') }}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{ $t('new_ui.home_page.section_newsletter.description.two') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import imageblue from '@/assets/images/sub/Top.png';
import imageadv from '@/assets/images/sub/imageadv.png';
import question from '@/assets/images/sub/ques.png';
import img from '@/assets/images/sub/ban1.png';
import secure from '@/assets/images/sub/Secure Payment.png';
import anycompany from '@/assets/images/sub/Any Company.png';
import touch from '@/assets/images/sub/Touch Free.png';
import pay1 from '@/assets/images/sub/pay1.png';
import pay2 from '@/assets/images/sub/pay2.png';
import registration from '@/assets/images/sub/Registration.png';
import payment from '@/assets/images/sub/Payment.png';
import crypto from '@/assets/images/sub/Crypto Wallet.png';
import smarter from '@/assets/images/sub/Shop Smarter.png';
import paywith from '@/assets/images/sub/Pay With Us.png';
import curveup from '@/assets/images/sub/Curve Arrow.png';
import curvedwn from '@/assets/images/sub/Curve_dwn.png';
import business from '@/assets/images/sub/business.png';
import mobile from '@/assets/images/sub/mobile_phn.png';
import qr from '@/assets/images/sub/qr.png';
import qr2 from '@/assets/images/sub/qr2.png';
import qr3 from '@/assets/images/sub/qr3.png';
import crypto1 from '@/assets/images/sub/crypto_news.png';
import ques from '@/assets/images/sub/info.png';
import customer from '@/assets/images/sub/Total Customers.png';
import satisfaction from '@/assets/images/sub/satisfaction.png';
import money from '@/assets/images/sub/money.png';
import author1 from '@/assets/images/sub/a1.png';

import SwiperCore, { Autoplay, Pagination } from 'swiper';
SwiperCore.use([Autoplay, Pagination]);
import lady from '@/assets/images/sub/world_Map.png';
export default {
	data: () => {
		return {
			img: {
				image1: img,
				image2: secure,
				image3: anycompany,
				image4: touch,
				image5: pay1,
				image6: pay2,
				image7: registration,
				image8: payment,
				image9: crypto,
				image10: smarter,
				image11: paywith,
				image12: curveup,
				image13: curvedwn,
				image15: lady,
				image16: business,
				image17: mobile,
				image18: qr,
				image19: qr2,
				image20: qr3,
				image21: crypto1,
				image22: ques,
				image23: customer,
				image24: satisfaction,
				image25: money,
				image31: author1,
				image50: imageblue,
				image51: imageadv,
				image52: question,
			},
			swiperOptions: {
				slidesPerView: 2,
				spaceBetween: 10,
				navigation: false,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			},
		};
	},
	mounted() {
		const styleTag = document.getElementById('custom-style');
		if (styleTag) {
			styleTag.disabled = true; // disables the styles without removing
			// OR: styleTag.remove(); // use this if you want to completely remove it
		}
	},
	beforeUnmount() {
		// Re-enable if you disabled it (optional)
		const styleTag = document.getElementById('custom-style');
		if (styleTag) {
			styleTag.disabled = false;
		}
	},
};
</script>
